/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'
import { WF_STEP_PROCESSING_TYPE, WF_STEP_TYPE } from '../../../../constants/workflow-steps'
import { isValid } from '../../../../utils/fileNameValidator'

export const createValidationSchema = () => {
  yup.setLocale({
    mixed: {
      required: 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR'
    }
  })

  yup.addMethod(yup.mixed, 'isValid', function (this: any) {
    return this.test('isValid', 'FILENAME_CONTAINS_INVALID_CHARACTERS', function (this: any, values: any) {
      return isValid(values, true)
    })
  })

  yup.addMethod(yup.mixed, 'isNotEmpty', function (this: any) {
    return this.test('isNotEmpty', 'GENERAL_FORM_FIELD_IS_REQUIRED_ERROR', function (this: any, values: any) {
      let valid = true

      if (!values || values === '') {
        valid = false
      } else if (Array.isArray(values) && !values.length) {
        valid = false
      }

      return valid
    })
  })

  const taskTeamStepLabel = yup
    .object()
    .shape({
      id: yup.number().nullable(),
      label: yup.string().nullable(),
      value: yup.number().nullable()
    })
    .nullable()
    .default(() => null)

  const someAtOnceErrorMessage = 'The # of users cannot be empty or set to 0, it must be set to 1 or more'
  const nofAllValue = yup
    .mixed()
    .when('processingType', {
      is: WF_STEP_PROCESSING_TYPE.N_OF_ALL,
      then: (schema: any) =>
        yup
          .number()
          .min(1, someAtOnceErrorMessage)
          .nullable()
          .transform((value: any) => (isNaN(value) ? undefined : value))
          .required(someAtOnceErrorMessage)
    })
    .nullable()

  return yup.object().shape({
    fsi: yup.object().nullable().required('MUST_SELECT_DOCUMENT_MSG_ERROR'),
    fileName: yup
      .string()
      .trim()
      .max(234, 'Filename must be at most 234 characters')
      .test('isValid', 'FILENAME_CONTAINS_INVALID_CHARACTERS', (value: any) => isValid(value, true))
      .required()
      .default(() => ''),
    description: yup
      .string()
      .max(254)
      .required()
      .default(() => ''),
    typeData: yup.object().shape({
      initialApprovers: yup.object().shape({
        type: yup
          .string()
          .oneOf(Object.values(WF_STEP_TYPE))
          .default(() => WF_STEP_TYPE.NOT_DEFINED),
        steps: yup
          .array()
          .of(
            yup.object().shape({
              taskTeamStepLabel: taskTeamStepLabel,
              processingType: yup.string().nullable().required(),
              nofAllValue: nofAllValue,
              merged: yup.array()
            })
          )
          .nullable()
          .default(() => [])
      }),
      approvers: yup.object().shape({
        type: yup
          .string()
          .oneOf(Object.values(WF_STEP_TYPE))
          .default(() => WF_STEP_TYPE.NOT_DEFINED),
        steps: yup
          .array()
          .of(
            yup.object().shape({
              taskTeamStepLabel: taskTeamStepLabel,
              processingType: yup.string().nullable().required(),
              nofAllValue: nofAllValue,
              merged: yup.array()
            })
          )
          .nullable()
          .default(() => [])
      })
    })
  })
}

export default createValidationSchema
